let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("7YoSv")).then(() => parcelRequire('3MgcY'));